module.exports = __webpack_public_path__ + "static/img/hd.99fc22f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/hd.png
// module id = Mdj3
// module chunks = 21